{
  "fr": {
    "upsell": {
      "categories": {
        "category": "Catégorie",
        "home_automation": "Domotique",
        "integration": "Intégration",
        "interior_decoration": "Décoration intérieure",
        "interior_doors": "Portes intérieures",
        "kitchen": "Cuisine",
        "marketing": "Marketing",
        "real_estate_agent": "Agent immobilier",
        "telecom": "Télécom",
        "wood_finishing": "Finition du bois"
      },
      "contact_us": "Intéressé? Contactez-nous",
      "decisions_partners": {
        "guidance": "Les partenaires de décision peuvent créer et/ou gérer des propositions s'ils y sont autorisés.",
        "intercom": "Bonjour Ziggu ! Je suis intéressé par la fonctionnalité Decision Partners. Pouvez-vous fournir plus d'informations? Cordialement, %{name}"
      },
      "decisions_proposals_multiple_approval": {
        "cta": "Chat avec nous pour en savoir plus",
        "description": "Vous en avez assez d'annuler l'approbation d'une proposition pour y apporter des modifications et recommencer depuis le début ? Le besoin d'approbations multiples ne devrait pas vous ralentir.",
        "description_2": "Permettez à vos clients d'approuver plusieurs propositions dans la même décision. Il n'est pas nécessaire d'annuler l'approbation d'une proposition existante ou de commencer une nouvelle décision.",
        "description_3": "Moins de tracas et plus de temps pour se concentrer sur ce qui compte vraiment : votre client !",
        "intercom": "Bonjour Ziggu ! Je souhaite que le client puisse approuver plusieurs propositions à l'intérieur d'une décision. Pouvez-vous me donner plus d'informations ? Je vous prie d'agréer, Madame, Monsieur, l'expression de mes salutations distinguées, %{name}",
        "premium_add_on": "Supplément Premium",
        "title": "Gagnez du temps grâce à l'extension flexible pour les propositions !"
      },
      "decisions_reminders": {
        "guidance": "Les rappels vous permettent d'informer automatiquement les clients qu'il y a des propositions en attente d'une décision.",
        "intercom": "Bonjour Ziggu! Je suis intéressé par la fonctionnalité Rappels. Pouvez-vous fournir plus d'informations? Cordialement, %{name}"
      },
      "financials": {
        "guidance": "Créez des échéanciers de paiement directement à partir des propositions approuvées et partagez-les avec vos clients via le portail client.<br>Gardez votre communication financière transparente et professionnelle, vos clients ont toujours une vue claire de ce qui est dû et quand.",
        "intercom": "Bonjour Ziggu ! Je suis intéressé par la fonctionnalité Finances pour les échéances sur les décisions. Pouvez-vous fournir plus d'informations ? Cordialement, %{name}"
      },
      "imInterested": "Je suis intéressé!",
      "intercom": "Bonjour Ziggu ! Je suis intéressé dans {upsell). Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
      "interestedToBeListed": "Intéressé à être répertorié ici",
      "lookingfor": "Que recherchez-vous ? Par exemple, visuels 3D, cuisine, télécom",
      "multilingual": {
        "announcements_body": "Vous pouvez déjà traduire vos actualités en {languages}. Partout ailleurs, la fonctionnalité multilingual vous laisse écrire une seule fois et chaque client le lit dans sa propre langue.",
        "bar_covered": "Vous publiez déjà en {language}",
        "bar_uncovered": "Vous ne publiez pas encore en {language}",
        "body": "Aujourd'hui, ils reçoivent tous la même version. Avec la fonctionnalité multilingual, chaque client lit ce contenu dans la langue qu'il a lui-même choisie.",
        "chip_tooltip": "{customers} client a {language} comme langue | {customers} clients ont {language} comme langue",
        "cta": "Demander plus d'infos",
        "cta_expand": "Voir les détails",
        "cta_sent": "Nous vous recontactons",
        "customers_count": "1 client | {count} clients",
        "error_intercom": "Nous n'avons pas pu envoyer votre question. Veuillez réessayer.",
        "headline": "Votre {count} client {scope} parle {languages} | Vos {count} clients {scope} parlent {languages}",
        "headline_single": "Votre {count} client {scope} parle {language}. | Tous vos {count} clients {scope} parlent {language}.",
        "intercom": "Je souhaite en savoir plus sur la fonctionnalité multilingual",
        "languages_count": "1 langue | {count} langues",
        "languages_other_count": "1 autre langue | {count} autres langues",
        "missing_add": "Ajouter",
        "missing_added": "{language} fait maintenant partie des langues de votre entreprise",
        "missing_hint": "Ce que vous ajoutez devient disponible comme langue de traduction partout, pour toute votre entreprise.",
        "missing_hint_announcements_only": "Ce que vous ajoutez devient une langue de traduction pour toute votre entreprise. Aujourd'hui, vous l'utilisez dans les actualités ; avec la fonctionnalité multilingual, partout ailleurs aussi.",
        "missing_no_permission": "L'ajout de langues d'entreprise nécessite le rôle de Propriétaire.",
        "missing_settings_link": "Gérer toutes les langues dans les paramètres de l'entreprise",
        "missing_title": "{count} client {scope} parle {languages} | {count} clients {scope} parlent {languages}",
        "plan": "Enterprise",
        "scope_project": "dans ce projet",
        "scope_selection": "dans cette sélection"
      },
      "not_included": "Intéressé par cette fonctionnalité",
      "project_email_forwarding": {
        "cta": "Transfert d'e-mails {project_name}",
        "description": "Permettez à tous les membres de votre équipe de transférer des e-mails directement à vos projets Ziggu.",
        "intercom": "Bonjour Ziggu ! Je suis intéressé par la fonctionnalité . Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "Project email forwarding",
          "title_sub": "Transférez les e-mails directement à vos projets Ziggu."
        },
        "title": "Nouveau! Transfert d'e-mails pour des projets",
        "youtube_id": "vLQtH9GzAXc"
      },
      "project_experience": {
        "contactme": "Vous pouvez me contacter pour cela!",
        "cta": "Améliorer l'image de marque de votre projet?",
        "description": "URL de projet personnalisée et écran de connexion <br/> Environnement de projet dédié lorsque vous êtes connecté <br/> E-mails de marque de projet <br/> Facilite la collaboration avec d'autres promoteurs immobiliers sur le même projet",
        "intercom": "Bonjour Ziggu ! Je suis intéressé par le module Project Experience. Pouvez-vous fournir plus d'informations ? Cordialement, %{name}",
        "marketplace": {
          "title": "Project experience",
          "title_sub": "Améliorez l'image de marque de votre projet avec une URL et un environnement de projet personnalisés"
        },
        "title": "Faites en sorte que vos clients se sentent chez eux avec la toute nouvelle <br>Project Experience !",
        "youtube_id": "f26cNo2rwWE"
      },
      "project_templates": {
        "cta": "Importer à partir d'un modèle ?",
        "cta2": "Importer ce modèle dans vos projets ? Cliquez ici pour débloquer cette fonctionnalité !",
        "description": "<p>Transformez votre gestion de projets grâce à des modèles préconstruits qui vous font gagner du temps et gardent votre équipe synchronisée.</p><br><p><strong>Avantages des modèles:</strong></p>\n<ul>\n    <li><strong>- Gagnez des heures</strong> sur les tâches répétitives—importez des cadres de projets entiers en quelques secondes.</li>\n    <li><strong>- Standardisation améliorée</strong> en ayant tout au même endroit, des tâches aux documents.</li>\n    <li><strong>- Boostez l'efficacité</strong> en automatisant les processus routiniers, afin que vous puissiez vous concentrer sur l'essentiel.</li>\n</ul>\n<br/><strong>Passez à la version supérieure dès aujourd'hui et accomplissez-en plus avec moins d'efforts !</strong>",
        "intercom": "Bonjour Ziggu ! Je suis intéressé par la fonctionnalité des modèles. Pouvez-vous me donner plus d'informations ? Je vous prie d'agréer, Madame, Monsieur, l'expression de mes salutations distinguées, %{name}",
        "marketplace": {
          "title": "Modèles",
          "title_sub": "Transformez votre façon de gérer les projets grâce à des modèles prédéfinis qui vous font gagner du temps et permettent à votre équipe de rester synchronisée."
        },
        "title": "Travailler plus intelligemment avec des modèles !"
      },
      "proposal_choice_lists": {
        "guidance": "Les listes de choix vous permettent de laisser les clients faire des choix dans des propositions.",
        "intercom": "Bonjour Ziggu! Je suis intéressé par la fonctionnalité Listes de choix. Pouvez-vous fournir plus d'informations? Cordialement, %{name}"
      },
      "signatures": {
        "cta_text": "Besoin de signatures pour vos documents ? Contactez-nous",
        "guidance": "Les signatures vous permettent de permettre aux clients de signer numériquement des documents importants.",
        "intercom": "Bonjour Ziggu! Je suis intéressé par la fonctionnalité Signatures. Pouvez-vous fournir plus d'informations ? Cordialement, %{name}"
      },
      "workflows": {
        "attach_body": "Astuce : les décisions et les enquêtes peuvent aussi être rattachées à une phase. Elles sont alors publiées automatiquement dès que la phase est atteinte.",
        "cta": "En savoir plus",
        "cta_sent": "Nous vous recontactons",
        "dismiss": "Pas maintenant",
        "intercom": "J’aimerais en savoir plus sur ce que les workflows apportent aux phases.",
        "move_hint_phases": "Astuce : une phase peut publier elle-même ses décisions, enquêtes et tâches dès qu'elle est atteinte.",
        "move_hint_tasks": "Astuce : une phase peut aussi publier elle-même ses décisions et enquêtes dès qu'elle est atteinte."
      },
      "workflows_elements": {
        "guidance": "Votre offre actuelle n'inclut pas ce type d'élément. Il reste sur la phase, mais les clients ne le recevront qu'après une mise à niveau.",
        "intercom": "Bonjour Ziggu! Je suis intéressé par le partage de décisions, d'enquêtes et de tâches via les phases. Pouvez-vous fournir plus d'informations? Cordialement, %{name}"
      }
    }
  }
}
